import { NavDropdown, type NavDropdownProps } from "react-bootstrap";
import styled from "styled-components";

type DarkNavDropdownProps = Omit<NavDropdownProps, "menuVariant">;

const DarkNavDropdown = (props: DarkNavDropdownProps) => {
  return <NavDropdown menuVariant="dark" {...props} />;
};

const StyledNavDropdown = styled(DarkNavDropdown)`
  .dropdown-menu {
    max-height: 400px;
    overflow-y: auto;
  }

  [data-bs-theme="light"] && .dropdown-menu {
    --bs-dropdown-divider-bg: rgba(255, 255, 255, 0.25);
  }
`;

const AANavDropdown = Object.assign(StyledNavDropdown, {
  Item: NavDropdown.Item,
  ItemText: NavDropdown.ItemText,
  Header: NavDropdown.Header,
  Divider: NavDropdown.Divider,
});

export default AANavDropdown;
